function selectorcaixetesesborrar() {
    if ($(this).closest('ol').find('li.selector').length > 1) {
        $(this).closest('li').remove();
    }
    return false;
}
function destinatarisesborrar() {
    if ($(this).closest('ol').find('li.opcio').length > 1) {
        $(this).closest('li').remove();
    }
    return false;
}
function inputOpcionsesborrar() {
    if ($(this).closest('ol').find('li.opcio').length > 1) {
        $(this).closest('li').remove();
    }
    return false;
}

$(document).ready(function() {
    vex.defaultOptions.className = "vex-theme-default";

    // tooltip bootstrap-tooltip.js
    $('*[rel=tooltip]').tooltip({
        animation: false
    });
    $('input[title]').tooltip({
        animation: false,
        placement: 'right'
    });
    $('.tooltip-large').tooltip({
        animation: false,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner large"></div></div>'
    });

    // enllaços externs en finestra nova
    $('a[rel=external]').attr('target', '_blank').addClass('external');

    // inicialitza select2
    if ($(".chzn-select").length > 0) {
        $(".chzn-select").select2({
            width: "100%"
        });
    }


    if ($(".flashMessenger").length > 0) {
        $(".flashMessenger").alert(
            window.setTimeout(function() {
                $(".flashMessenger").alert('close');
            }, 10000)
        );
    }

    if ($(".datepicker").length > 0 || $(".datetimepicker").length > 0) {
        // inicialitzar datapickers
        $.datepicker.setDefaults($.datepicker.regional.ca);
        $.timepicker.regional.ca = {
            timeOnlyTitle: 'Tria l\'hora',
            timeText: 'Hora',
            hourText: 'Hora',
            minuteText: 'Minut',
            secondText: 'Segon',
            millisecText: 'Milisegon',
            currentText: 'Ara',
            closeText: 'Fet',
            ampm: false
        };
        $.timepicker.setDefaults($.timepicker.regional.ca);
        if ($(".datepicker").length > 0) {
            $(".datepicker").datepicker({
                dateFormat: "dd/mm/yy"
            });
            // $(".datepicker").attr('readonly', 'readonly');
        }
        if ($(".datetimepicker").length > 0) {
            $(".datetimepicker").datetimepicker({
                dateFormat: "dd/mm/yy",
                timeFormat: "HH:mm"
            });
        }
    }

    if ($(".colorpicker").length > 0) {
        // inicialitzar datapickers
        if ($(".colorpicker").length > 0) {
            $(".colorpicker").colorpicker({
                //dateFormat: "dd/mm/yy"
            });
        }
    }

    // inicialitza validator
    if (jQuery.validator) {
        jQuery.validator.setDefaults({
            errorElement: 'span',
            errorPlacement: function(error, element) {
                var editor = element.parent().find('div.cke');
                if (editor.length > 0) {
                    error.css('display', 'inline-block').css('margin-top', '3px').insertAfter(editor);
                } else if (element.is('[type=radio]') || element.is('[type=checkbox]')) {
                    error.insertAfter(element.closest('label'));
                } else if (element.parent('.input-group').length) {
                    error.insertAfter(element.parent());
                } else {
                    error.insertAfter(element);
                }
            },
            highlight: function(element) {
                $(element).closest('.form-group').addClass('has-error');
            },
            unhighlight: function(element) {
                $(element).closest('.form-group').removeClass('has-error');
            }
        });
        // missatge a la mateixa línea
        $('.validate').each(function() {
            $(this).validate();
        });
        // sense missatge
        $('.validateNoMessage').each(function() {
            $(this).validate({
                errorPlacement: function(error, element) {
                    if (element.is('[type=radio]') || element.is('[type=checkbox]')) {
                        error.insertAfter(element.closest('label'));
                    } else if (element.parent('.input-group').length) {
                        error.insertAfter(element.parent());
                    } else {
                        error.insertAfter(element);
                    }
                }
            });
        });
        // missatge sota el input
        $('.validateBlock').each(function() {
            $(this).validate({
                errorElement: 'div',
                errorPlacement: function(error, element) {
                    if (element.is('[type=radio]') || element.is('[type=checkbox]')) {
                        error.insertAfter(element.closest('label'));
                    } else if (element.parent('.input-group').length) {
                        error.insertAfter(element.parent());
                    } else {
                        error.insertAfter(element);
                    }
                }
            });
        });

        $('input.folderNameCheck').each(function() {
            var input = $(this);
            input.rules('add', {
                remote: {
                    url: '../carpetes/checkNameAjax.php',
                    type: "post",
                    data: {
                        current: input.val(),
                        parent: input.data('parent'),
                        lg: input.attr('lang')
                    }
                },
                messages: {
                    remote: 'Nom no disponible'
                }
            });
        });
    }

    // selector domini de la capçalera
    $('#changeDomain input').hide();
    $('#changeDomain select').bind('change', function() {
        $(this).parent().submit();
    });

    // portada
    if ($("#anarcarpetes").length > 0) {
        $("#anarcarpetes").change(function() {
            window.location = $(this).val();
        });
    }
    // fi portada

    // usuaris
    if ($("input[data-random]").length > 0) {
        $("input[data-random]").each(function(){
            var randomInput = $(this);
            randomInput.after('<p><a href="#" class="randomPass" style="margin-top: 4px;"><i class="fa fa-sync" aria-hidden="true"></i> ' + randomInput.attr('data-random') + '</a></p>');
            $('.randomPass').bind('click', function(event) {
                event.preventDefault();
                var password = $.passGen({'length' : 12, 'numeric' : true, 'lowercase' : true, 'uppercase' : true, 'special' : false});
                var oldPass = $('#' + randomInput.attr('id'));
                var newPass = oldPass.clone(true);
                newPass.val(password).attr('type', 'text');
                newPass.insertBefore(oldPass);
                oldPass.remove();
                $('#' + randomInput.attr('id') + '_bis').val(password);
            });
        });
    }
    if ($('#expireData').length > 0 && $('#enable_expiration').length > 0) {
        if (!$('#enable_expiration').is(':checked')) {
            $('#expireData').hide();
        }
        $('#enable_expiration').bind('change', function() {
            $('#expireData').toggle($('#enable_expiration').is(':checked'));
        });
    }
    // fi usuaris

    // carpetes
    if ($('#active_domini').length > 0 && $('#active_domini_url').length > 0) {
        if ($('#active_domini').not(':checked')) {
            $('#active_domini_url').hide();
        }
        $('#active_domini').bind('change', function() {
            $('#act0ive_domini_url').toggle();
        });
    }
    // fi carpetes

    // camps si check marcat
    if ($('input[data-extra]').length > 0) {
        $('input[data-extra]').each(function(){
            var extra = $(this).data('extra');
            if ($(this).prop('checked') == false) {
                $('#'+extra).hide();
            }
            $(this).bind('change', function() {
                var extra = $(this).data('extra');
                $('#'+extra).toggle();
            });
        });
    }
    // fi camps si check marcat


    // cerca
    $('.search #ordenar').bind('change', function() {
        $(this).closest('form').submit();
    });

    $('.popupIframe').each(function() {
        $(this).magnificPopup({
            type: 'iframe'
        });
    });

    $('.popupImage').each(function() {
        $(this).magnificPopup({
            type: 'image',
            image: {
                titleSrc: 'title',
                verticalFit: true
            }
        });
    });

    $('.template-gallery').each(function() {
        $(this).magnificPopup({
            delegate: 'a.template-img',
            type: 'image',
            gallery: {
                enabled: true,
                navigateByImgClick: true
            },
            image: {
                titleSrc: 'title',
                verticalFit: true
            }
        });
    });

    $('.selectorcaixetes').each(function() {
        var selectorcaixetes = $(this);
        if (selectorcaixetes.data('disabled')) {
            selectorcaixetes.find('.move, .add, .delete').hide();
            return;
        }

        var selectorcaixetesUltim = selectorcaixetes.find('li.selector:last').html();

        selectorcaixetes.find('ol').sortable({
            handle: ".move"
        });
        selectorcaixetes.find('a.delete').on('click', selectorcaixetesesborrar);

        selectorcaixetes.find('a.add').bind('click', function() {
            var ol = $(this).closest('.selectorcaixetes').find('ol');
            var name = ol.find('select').attr('name');
            ol.append('<li class="selector">' + selectorcaixetesUltim + '</li>');
            ol.find('li.selector:last select').attr('name', name);
            ol.find('li.selector:last select').select2({
                width: "75%",
                allowClear: true
            });
            ol.find('li.selector:last a.delete').on('click', selectorcaixetesesborrar);
            return false;
        });

        selectorcaixetes.find('li.selector select').select2({
            width: "75%",
            allowClear: true
        });
    });

    var destinataris = $('.destinataris');
    if (destinataris.length > 0) {
        var destinatarisUltim = destinataris.find('li.opcio:last').html();

        destinataris.find('a.delete').on('click', destinatarisesborrar);

        destinataris.find('a.add').bind('click', function() {
            var ol = $(this).parent().find('ol');
            ol.append('<li class="opcio">' + destinatarisUltim + '</li>');
            ol.find('li.opcio:last a.delete').on('click', destinatarisesborrar);
            return false;
        });
    }

    var inputOpcions = $('#inputOpcions');
    if (inputOpcions.length > 0) {
        var inputOpcionsUltim = inputOpcions.find('li.opcio:last').html();

        inputOpcions.find('ol').sortable({
            handle: ".move"
        });

        inputOpcions.find('a.delete').on('click', inputOpcionsesborrar);

        inputOpcions.find('a.add').bind('click', function() {
            var ol = $(this).parent().find('ol');
            ol.append('<li class="opcio">' + inputOpcionsUltim + '</li>');
            ol.find('li.opcio:last a.delete').on('click', inputOpcionsesborrar);
            ol.find('*[rel=tooltip]').tooltip({
                animation: false
            });
            return false;
        });
    }

    $('textarea.autosize').each(function() {
        autosize($(this));
    });

    $('[data-toggle="popover"]').popover();

    if ($('.check-all').length > 0) {
        $('.check-all').each(function() {
            var options = {
                container: $(this).closest('.check-all-group'),
                showIndeterminate: true
            };
            $(this).checkAll(options);
        });
    }

    $('.multiFields').each(function() {
        var multi = $(this);
        if (multi.data('disabled')) {
            multi.find('.move, .add, .delete').hide();
            return;
        }

        var newField = multi.find('ul').data('new');
        var next = multi.find('ul').data('next');
        var max = multi.find('ul').data('max');

        multi.find('.imageContainer div.deleteImage').each(function() {
            $(this).append('<a href="#" class="btn btn-danger deleteBtn"><i class="fa fa-trash"></i></a>');
            $(this).find('label').hide();
            $(this).find('a.deleteBtn').on('click', function() {
                $(this).closest('.imageContainer').find('.popupImage').remove();
                $(this).parent().find('input').attr('checked', 'checked');
                $(this).remove();
                return false;
            });
        });

        multi.find('ul').sortable({
            handle: ".move",
            start: function(event, ui) {
                ui.item.find("textarea[class*='editor']").each(function() {
                    var ckeditor = CKEDITOR.instances[$(this).attr('name')];
                    ckeditor.destroy();
                });
            },
            stop: function(event, ui) {
                $(this).find('input.order').each(function(idx) {
                    $(this).val(idx);
                });

                ui.item.find("textarea[class*='editor']").each(function() {
                    var editorClassName = $(this).attr('class').match(/editor\w+/);
                    if (editorClassName) {
                        addEditor($(this), editorClassName[0].substring(6));
                    }
                });
            }
        });
/*        multi.on('click', '.collapse-btn i.fa', function(){
            $(this).toggleClass('fa-chevron-down fa-chevron-up');
        });*/
        multi.on('hidden.bs.collapse', '.collapse', function (){
            //$(this).closest('.multiContent').find('.toclose').hide()
            $(this).closest('.multiContent').find('.toopen').show()
        }).on('hide.bs.collapse', '.collapse', function (){
            $(this).closest('.multiContent').find('.toclose').hide()
            $(this).closest('.multiContent').find('.toopen').hide()
        }).on('shown.bs.collapse', '.collapse', function(){
            //$(this).closest('.multiContent').find('.toopen').hide()
            $(this).closest('.multiContent').find('.toclose').show()
        }).on('show.bs.collapse', '.collapse', function(){
            $(this).closest('.multiContent').find('.toopen').hide()
            $(this).closest('.multiContent').find('.toclose').hide()
        });

        if (max > 0 && multi.find('li').length >= max) {
            multi.find('a.add').hide();
        } else {
            multi.find('a.add').show();
        }


        multi.find('ul').on('click', 'li a.delete', function(event) {
            event.preventDefault();
            if (max > 0 && $(this).closest('ul').find('li').length > max) {
                $(this).closest('div.multiFields').find('a.add').hide();
            } else {
                $(this).closest('div.multiFields').find('a.add').show();
            }
            $(this).closest('li').remove();
        });

        multi.find('a.add').bind('click', function(event) {
            event.preventDefault();

            var ul = $(this).closest('div').find('ul');

            if (max > 0 && ul.find('li').length >= max) {
                return false;
            }

            ul.append(newField.replace(/\[id\]/g, '[' + next + ']').replace(/_collapse_id/g, '_collapse_' + next));

            ul.find('li:last-child').find("textarea[class*='editor']").each(function() {
                var editorClassName = $(this).attr('class').match(/editor\w+/);
                if (editorClassName) {
                    addEditor($(this), editorClassName[0].substring(6));
                }
            });

            ul.find('input.order').each(function(idx) {
                $(this).val(idx);
            });

/*            ul.find('li:last a.delete').on('click', function(event) {
                event.preventDefault();
                $(this).closest('li').remove();
                console.log(ul.find('li').length);
                if (max > 0 && ul.find('li').length >= max) {
                    $(this).closest('div').find('a.add').hide();
                } else {
                    $(this).closest('div').find('a.add').show();
                }
            });*/
            ul.find('*[rel=tooltip]').tooltip({
                animation: false
            });
            next++;

            if (max > 0 && ul.find('li').length >= max) {
                $(this).hide();
            } else {
                $(this).show();
            }


            return false;
        });
    });

    $("input[autofocus]").trigger("focus");



    jQuery.validator.addMethod('unique', function(value, element, param) {
        'use strict';
        var result = false;
        var old = $(element).attr('value');

        $.ajax({
            type:"POST",
            async: false,
            url: param, // script to validate in server side
            data: {value: value, first: old},
            success: function(data) {
                result = (data == true) ? true : false;
            }
        });
        return this.optional(element) || result;
    }, 'Please enter another value, this field does not allow duplicates.');

    jQuery.validator.addMethod('passwordCheck', function(value, element, param) {
        'use strict';
        var result = false;
        $.ajax({
            type:"POST",
            async: false,
            url: param, // script to validate in server side
            data: {value: value},
            success: function(data) {
                result = (data == true) ? true : false;
            }
        });
        return this.optional(element) || result;
    }, 'It is mandatory to use strong passwords.');

    var lang = $('html').attr('lang');
    if (lang === 'ca') {
        jQuery.extend(jQuery.validator.messages, {
            unique: 'Si us plau, introdueixi un altre valor, aquest camp no permet duplicats.',
            passwordCheck: 'És obligatori l\'ús de claus fortes'
        });
    } else if (lang === 'es') {
        jQuery.extend(jQuery.validator.messages, {
            unique: 'Por favor, introduzca otro valor, este campo no permite duplicados.',
            passwordCheck: 'Es obligatorio el uso de claves fuertes'
        });
    }


    if ($('#REBRE_EMAILS').length) {
        if ($('#REBRE_EMAILS').is(':not(:checked)')) {
            $('.destinataris').hide();
        }
        $('#REBRE_EMAILS').bind('change', function(){
            $('.destinataris').toggle();
        });
        $( ".opcio input" ).rules( "add", {
            required: function(elem){
                return $("#REBRE_EMAILS:checked").length > 0;
            }
        });
    }

    if ($('.groupVisibility').length) {
        if ($('#VISIBLE_FOR_ALL_GROUPS').is(':checked')) {
            $('.groupSelector').show();
        } else {
            $('.groupSelector').hide();
        }
        $('body').on('change', '#VISIBLE_FOR_ALL_GROUPS', function(){
            if ($(this).is(':checked')) {
                $('.groupSelector').show();
            } else {
                $('.groupSelector').hide();
            }
        });
    }


    if ($("select.template-type").length > 0) {
        $("select.template-type").each(function(){
            var value = $(this).val();
            var extra = $(this).closest('.row').find('.extra');
            extra.each(function(){
                var elem = $(this);
                if (elem.hasClass(value)) {
                    elem.show();
                    elem.find('input, select').attr('disabled', false);
                } else {
                    elem.hide();
                    elem.find('input, select').attr('disabled', true);
                }
            });
        }).on('change', function(){
            var value = $(this).val();
            var extra = $(this).closest('.row').find('.extra');
            extra.each(function(){
                var elem = $(this);
                if (elem.hasClass(value)) {
                    elem.show();
                    elem.find('input, select').attr('disabled', false);
                } else {
                    elem.hide();
                    elem.find('input, select').attr('disabled', true);
                }

            });
        });
    }

    if ($(".form-selector").length > 0) {
        function formControl(elem) {
            var select = elem.find('select');
            elem.find('.form-texts').toggle(select.val() !== '');
            elem.find('.formExport').toggle(select.val() !== '');
            elem.find('.formEdit').toggle(select.val() !== '');
            elem.find('.formView').toggle(select.val() !== '');
            elem.find('.formAdd').toggle(select.val()  === '');
            if (select.val() !== '') {
                elem.find('.formExport').attr('href', '../formularis/export/index.php?ID='+select.val());
                elem.find('.formEdit').attr('href', '../formularis/edita.php?ID='+select.val());
                elem.find('.formView').attr('href', '../formularis/veure.php?id='+select.val());
            } else {
                elem.find('.formExport').attr('href', '#');
                elem.find('.formEdit').attr('href', '#');
                elem.find('.formView').attr('href', '#');
            }
        }

        $(".form-selector").each(function(){
            formControl($(this));
            $(this).find('select').on('change', function(){
                formControl($(this).closest('.form-selector'));
            });
        });
    }

    $('.enableChecker').each(function(){
        var checker = $(this);
        var checkerId = checker.attr('id');
        var enableChecker = function() {
            var content = $('#'+checkerId+'-content');
            content.toggle(checker.is(':checked'));
            content.find('input,select').prop('disabled', checker.is(':checked') == false);
        };
        checker.on('change', enableChecker);
        enableChecker();
    });

    $('.fileThumbnail .deleteFile input').on('change', function(){
        $(this).closest('div').find('a').remove();
        $(this).closest('div').hide();
    });


    $('.multipleOptions').each(function() {
        var multi = $(this);
        var newField = multi.find('ul').data('new');

        multi.find('ul').sortable({
            handle: ".move",
        });


        multi.find('ul').on('click', 'li a.delete', function(event) {
            event.preventDefault();
            if (multi.find('ul li').length <= 1) {
                return;
            }
            $(this).closest('li').remove();
        });

        multi.find('a.add').bind('click', function(event) {
            event.preventDefault();
            var ul = $(this).closest('div').find('ul');

            ul.append(newField);

            ul.find('*[rel=tooltip]').tooltip({
                animation: false
            });

            return false;
        });
    });

    var langnav = $('div.idiomes[data-sticky]');
    if (langnav.length > 0) {
        var sticky = langnav.offset();
        var stickyWith = langnav.width();
        langnav.width(stickyWith);
        window.onscroll = function() {
            if (window.pageYOffset >= sticky.top) {
                langnav.addClass('sticky');

            } else {
                langnav.removeClass('sticky');
            }

        };
    }


    $('ol.templateSortablefields').each(function() {
        $(this).sortable({
            handle: ".move"
        });
    });

//templateSortablefields
//templateField

    $('.editoraForm fieldset input, .editoraForm fieldset select, .editoraForm fieldset textarea, .editoraForm fieldset checkbox, .editoraForm fieldset radio').not('[disabled]').not('[type="file"]').each(function(){
        $(this).on('change', function(){
console.log('change');
            var value = $(this).val();
            var id = $(this).attr('id');

            $('[data-rel="'+id+'"]').val(value);
        });
    });
});
